var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDigiPaySingleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Digipay_Sign 2",
    clipPath: "url(#clip0_1717_24397)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.3441 0H0.850098V2.794C0.850098 4.89601 2.55404 6.59995 4.65605 6.59995H15.1501V3.80595C15.1501 1.70394 13.4461 0 11.3441 0Z",
    fill: "#0038FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M4.58344 7.69995C2.52149 7.69995 0.850098 9.37134 0.850098 11.4333V21.9999H3.6441C5.74611 21.9999 7.45005 20.296 7.45005 18.194V14.2999H11.4167C13.4787 14.2999 15.1501 12.6285 15.1501 10.5666V7.69995H4.58344Z",
    fill: "#0038FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1717_24397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3,
    height: 22,
    fill: "white",
    transform: "translate(0.850098)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigiPaySingleLogo);
export default __webpack_public_path__ + "static/media/digiPaySingleLogo.13e6d6b2169ccbddbf0fc8e9401200ea.svg";
export { ForwardRef as ReactComponent };